<template>
  <component :is="tag">
    <slot>{{ text }}</slot>
    <slot name="separator" v-if="show">{{ separator }}</slot>
  </component>
</template>
<script>
export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
    tag: {
      type: String,
      default: "span",
    },
    separator: {
      type: String,
      default: ", ",
    },
    text: {
      type: String,
      default: "",
    },
  },
  computed: {
    show() {
      if (this.index + 1 < this.length) return true;
      return false;
    },
  },
};
</script>
